import { Record } from 'immutable'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'
import { IPotentialProfit, PotentialProfit } from './PotentialProfit'

export interface IProjectedPipeline {
  readonly user: IAssociatedContact
  readonly month: number
  readonly year: number
  readonly profit: IPotentialProfit
}

const ProjectedPipelineRecord = Record({
  month: 0,
  profit: undefined,
  user: undefined,
  year: 0,
})

export class ProjectedPipeline extends ProjectedPipelineRecord
  implements IProjectedPipeline {
  public static fromJS(initialState?: Partial<IProjectedPipeline>) {
    if (!initialState) {
      return new ProjectedPipeline()
    }

    const { profit, user, ...rest } = initialState

    return new ProjectedPipeline({
      profit: PotentialProfit.fromJS(profit),
      user: AssociatedContact.fromJS(user),
      ...rest,
    })
  }

  public readonly user: IAssociatedContact
  public readonly month: number
  public readonly year: number
  public readonly profit: IPotentialProfit

  constructor(props?: Partial<ProjectedPipeline>) {
    props ? super(props) : super()
  }
}
